const VERSION: string = '0.1.7-prod.5'
export default VERSION;
